export const alert = {
    namespaced: true,
    state: {
        isValid: null,
        color: null,
        message: null
    },
    actions: {
        success({ commit }, message) {
            commit('success', message);
        },
        error({ commit }, message) {
            commit('error', message);
        },
        clear({ commit }) {
            commit('clear');
        }
    },
    mutations: {
        success(state, message) {
            state.isValid = true;
            state.color = 'green';
            state.message = message;
        },
        error(state, message) {
            state.isValid = true;
            state.color = 'red';
            state.message = message;
        },
        clear(state) {
            state.isValid = false;
            state.color = null;
            state.message = null;
        }
    }
}